import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';

import Image from '../Image';
import Container from '../Container';
import HeroText from '../HeroText';
import Header from '../Header';
import Footer from '../Footer';
import SectionHeader from '../SectionHeader';
// import founders from '../images/founders.jpg';

import workForImage from '../images/teachers-work-for.png';
import styles from './about.css';

const { div, p } = hh(h);

const About = (props) => {
    return div({className: styles.container}, [
        h(Header),
        h(Container, {theme: 'red', size: 'big'}, [
            h(HeroText, {subText: 'Code at Uni is on a mission to help students acquire the skills they need for the future of work.'}, 'About')]),
        h(Container, {size: 'big'}, [
            h(SectionHeader, {theme: 'one'}, 'Our Story'),

            div({className: styles.storyContainer}, [
                p({className: styles.story}, 'Since 2013 we have taught the most important digital skills to thousands of students across the UK.'),
                p({className: styles.story}, 'We’ve partnered with some of the best universities to deliver engaging and intensive courses that help students to develop the practical digital skills they need to succeed in the job market. '),
                p({className: styles.story}, 'Our courses take place on university campuses and are taught by expert instructors from some of the best technology companies in the world.')
            ])
        ]),
        h(Container, {className: styles.theBest}, [
            h(SectionHeader, {theme: 'one', classes: [styles.theBestImageHeader]}, 'Our teachers work for some of the world’s best companies'),
            h(Image, {
              src: workForImage,
              alt: 'Companies our teachers work for'
            })
        ]),
        div({className: styles.theBestHeader}, [
          div({className: styles.pictureText}, [
            p('Our teachers are full-time professional developers from industry who share our passion for education. They all have extensive experience working in the business environment as developers - this real world experience means they always relate technical concepts to tangible outcomes that students are more familiar with.') 
          ])
        ]),
        h(Container, {size: 'big'}, [
          h(Footer)
        ])
    ]);
};


export default About;



/** WEBPACK FOOTER **
 ** ./src/About/index.js
 **/